import { GetFreightCost, GetFreightCostResult } from "@tSurya/Services/GetFreightCostService";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";
import isApiError from "@insite/client-framework/Common/isApiError";

type GetFreightCostTypeParameter = HasOnSuccess<GetFreightCostResult[]> & HasOnError;

type HandlerType = CustomApiHandler<GetFreightCostTypeParameter, GetFreightCostResult[]>;

// export const PopulateApiParameter: HandlerType = props =>{
//     props.apiParameter = props.parameter
// }

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await GetFreightCost();
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [RequestDataFromApi, ExecuteOnSuccessCallback];

const GetFreightCostTypeParameter = createHandlerChainRunner(chain, "GetFreightCostTypeParameter");
export default GetFreightCostTypeParameter;
